import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import GestaoAcessoService from 'services/GestaoAcessoService'

export const initialState = {
  loading: false,
  message: '',
  showMessage: false,
  redirect: '',
  pagination: {
    content: [],
    totalElements: 0,
    totalPages: 0,
    currentPage: 0,
    pageSize: 10,
  },
  veiculosDoLogin: [],
}

export const listar = createAsyncThunk('gestaoAcesso/listar', async (params, { rejectWithValue }) => {
  try { return await GestaoAcessoService.listar(params) }
  catch (err) { return rejectWithValue(err.response?.data?.message || 'Erro ao listar logins') }
})

export const criar = createAsyncThunk('gestaoAcesso/criar', async (data, { rejectWithValue }) => {
  try { return await GestaoAcessoService.criar(data) }
  catch (err) { return rejectWithValue(err.response?.data?.message || 'Erro ao criar login') }
})

export const editar = createAsyncThunk('gestaoAcesso/editar', async ({ id, data }, { rejectWithValue }) => {
  try { return await GestaoAcessoService.editar(id, data) }
  catch (err) { return rejectWithValue(err.response?.data?.message || 'Erro ao editar login') }
})

export const titulares = createAsyncThunk('gestaoAcesso/titulares', async (_, { rejectWithValue }) => {
  try { return await GestaoAcessoService.titulares() }
  catch (err) { return rejectWithValue(err.response?.data?.message || 'Erro ao listar titulares') }
})

export const inativar = createAsyncThunk('gestaoAcesso/inativar', async ({ id, contratoId } = {}, { rejectWithValue }) => {
  try { return await GestaoAcessoService.inativar(id, contratoId) }
  catch (err) { return rejectWithValue(err.response?.data?.message || 'Erro ao inativar login') }
})

export const veiculosDoLogin = createAsyncThunk('gestaoAcesso/veiculosDoLogin', async (id, { rejectWithValue }) => {
  try { return await GestaoAcessoService.veiculosDoLogin(id) }
  catch (err) { return rejectWithValue(err.response?.data?.message || 'Erro ao buscar veículos do login') }
})

export const vincular = createAsyncThunk('gestaoAcesso/vincular', async ({ id, rastreadoresIds }, { rejectWithValue }) => {
  try { return await GestaoAcessoService.vincular(id, rastreadoresIds) }
  catch (err) { return rejectWithValue(err.response?.data?.message || 'Erro ao vincular veículos') }
})

export const desvincular = createAsyncThunk('gestaoAcesso/desvincular', async ({ id, rastreadoresIds }, { rejectWithValue }) => {
  try { return await GestaoAcessoService.desvincular(id, rastreadoresIds) }
  catch (err) { return rejectWithValue(err.response?.data?.message || 'Erro ao desvincular veículos') }
})

export const criarGestor = createAsyncThunk('gestaoAcesso/criarGestor', async (data, { rejectWithValue }) => {
  try { return await GestaoAcessoService.criarGestor(data) }
  catch (err) { return rejectWithValue(err.response?.data?.message || 'Erro ao criar gestor de frotas') }
})

export const concederContratos = createAsyncThunk('gestaoAcesso/concederContratos', async ({ id, contratosIds }, { rejectWithValue }) => {
  try { return await GestaoAcessoService.concederContratos(id, contratosIds) }
  catch (err) { return rejectWithValue(err.response?.data?.message || 'Erro ao conceder contratos') }
})

export const gestaoAcessoSlice = createSlice({
  name: 'gestaoAcesso',
  initialState,
  reducers: {
    limparMensagem: (state) => { state.message = ''; state.showMessage = false },
    limparRedirect: (state) => { state.redirect = '' },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listar.pending, (state) => { state.loading = true })
      .addCase(listar.fulfilled, (state, action) => {
        state.loading = false
        const p = action.payload
        if (Array.isArray(p)) {
          state.pagination = {
            content: p,
            totalElements: p.length,
            totalPages: 1,
            currentPage: 0,
            pageSize: p.length || 10,
          }
        } else {
          const pg = p || {}
          state.pagination = {
            content: pg.content || [],
            totalElements: pg.totalElements || 0,
            totalPages: pg.totalPages || 0,
            currentPage: typeof pg.number === 'number' ? pg.number : 0,
            pageSize: pg.size || 10,
          }
        }
      })
      .addCase(listar.rejected, (state, action) => { state.loading = false; state.message = action.payload; state.showMessage = true })
      .addCase(veiculosDoLogin.fulfilled, (state, action) => { state.veiculosDoLogin = action.payload || [] })
    ;[criar, editar, inativar, vincular, desvincular, criarGestor, concederContratos].forEach((thunk) => {
      builder
        .addCase(thunk.pending, (state) => { state.loading = true })
        .addCase(thunk.fulfilled, (state) => { state.loading = false; state.redirect = '/app/gestao-acesso/default' })
        .addCase(thunk.rejected, (state, action) => { state.loading = false; state.message = action.payload; state.showMessage = true })
    })
  },
})

export const { limparMensagem, limparRedirect } = gestaoAcessoSlice.actions
export default gestaoAcessoSlice.reducer
